export const SET_TRANSFER_RESPONSIBLE = 'SET_TRANSFER_RESPONSIBLE';

export const companySettingsAction = {
  setTransferResponsibles: (transferResponsible) => ({
    type: SET_TRANSFER_RESPONSIBLE,
    payload: transferResponsible
  })
};
